/**
 * Named z-index layers (ui-audit B6): one source of truth for stacking order.
 * Use inline `style={{ zIndex: Z.x }}` — Tailwind arbitrary z classes are
 * hard to audit, and stacking bugs come from magic numbers scattered around.
 */
export const Z = {
  /** Sticky year-group headers inside scrolling lists. */
  stickyHeader: 35,
  /** Sticky page toolbars / filter bars. */
  toolbar: 40,
  /** Desktop sidebar + mobile bottom nav. */
  navigation: 50,
  /** First-run module tour — above nav, below command palette. */
  tour: 60,
  /** ⌘K command palette — above content, BELOW modals: a modal always wins. */
  palette: 70,
  /** Interruptive modals (confirmations, forms). */
  modal: 80,
  /** Toasts / sonner. */
  toast: 100,
} as const;
